const mapLayers = {
  options: {
    layers: 'שכבות',
    ev: 'טעינת EV',
    bookings: 'מפת חום',
    heatMap: 'הזמנות',
  },
  legend: {
    powerType: {
      slow: 'איטי',
      fast: 'מהיר',
      turbo: 'טורבו',
    },

    availability: {
      available: 'זמין',
      notAvailable: 'לא זמין',
      selected: 'נבחר',
      broken: 'שבור',
      unknown: 'לא ידוע',
    },
  },
};

export default mapLayers;
